import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth.js';
import { ROLES } from '../_Shared/navigation.js';

export default function Home() {
  const { user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    let path = '/';
    switch(user.role) {
      case ROLES.ADMIN:
        path = '/reports';
        break;
      default:
        path = '/ledger';
    };

    navigate(path)
  }, [user, navigate]);

  return (<></>);
};
